import { locale } from 'svelte-i18n';
import { formatLocale } from 'd3-format';
import { derived } from 'svelte/store';

const options = {
  de: {
    decimal: ',',
    separator: '.',
    thousands: '.'
  },
  en: {
    decimal: '.',
    separator: ',',
    thousands: ','
  }
};

const d3FormatLocalized = derived(locale, ($locale) => {
  const formatOptions = options[$locale] || options.de;
  return formatLocale({ ...formatOptions, grouping: [3] });
});

export const formatNumber = derived(d3FormatLocalized, ($d3FormatLocalized) => {
  return (number, format = ',') =>
    number != null ? $d3FormatLocalized.format(format)(number) : number;
});

export const formatPercentage = derived(
  d3FormatLocalized,
  ($d3FormatLocalized) => {
    return (number, format = '.2%') =>
      number != null ? $d3FormatLocalized.format(format)(number) : number;
  }
);
